import React from "react";
import { parseSpecialCharacter } from "@app/lib/parse-special";
type UseProductArgs =
  | {
      source: "searchspring";
      data: any;
    }
  | {
      source: "shopify";
      data: any;
    }
  | {
      source: "shopify-section";
      data: any;
    }
  | {
      source: "searchspring-recommdation";
      data: any;
    };

type ProductStandard = {
  id: string;
  name: string;
  url: string;
  imageUrl: string;
  price: number;
  compareAtPrice: number;
  membersPrice: number;
  tags: string[];
  swatches: any[];
  images: { secondaryImage: string };
  collectionId?: string[];
};

const IMAGE_PLACEHOLDER =
  "https://cdn.shopify.com/s/files/1/0919/0116/5858/files/096f8e84-4843-4737-a536-07b566d7c33f_600x600.jpg?v=1742331151";

function getSecondaryImage(imageString: string, split: "|") {
  const images = imageString?.split(split) ?? [];
  if (!images || images?.length <= 1) {
    return { secondaryImage: "" };
  }
  const secondaryImage = images[1];
  return {
    secondaryImage,
  };
}

const handleSwatchData = (data: any) => {
  if (data?.mfield_dotapparel21_siblings) {
    return JSON.parse(((data?.mfield_dotapparel21_siblings as string) ?? "[]")?.split("&quot;")?.join('"'));
  }
  return data?.siblings ?? [];
};

export function useFormatProduct({ source, data }: UseProductArgs): ProductStandard {
  const swatches = handleSwatchData(data);
  const images = getSecondaryImage(data?.images ?? "", "|");

  const path = window.location.pathname;
  const isCollectionPage = path.includes("/collections/") && !path.includes("/products/");
  const url = isCollectionPage ? `${path}${data.url}` : data.url;

  switch (source) {
    case "searchspring-recommdation":
      return {
        id: data.id,
        name: parseSpecialCharacter(data.name),
        url,
        imageUrl: data.imageUrl,
        price: parseFloat(data.price) || 0,
        compareAtPrice: parseFloat(data.attributes.variant_compare_at_price) || 0,
        membersPrice: parseFloat(data.attributes.variant_mfield_pricing_members) || 0,
        tags: data.tags,
        swatches: swatches,
        images: images,
        collectionId: data?.attributes.collection_id,
      };
    case "searchspring":
      return {
        id: data.variant_product_id,
        name: parseSpecialCharacter(data.name),
        url,
        imageUrl: data.imageUrl,
        price: parseFloat(data.price) || 0,
        compareAtPrice: parseFloat(data.variant_compare_at_price) || 0,
        membersPrice: parseFloat(data.variant_mfield_pricing_members) || 0,
        tags: data.tags,
        swatches: swatches,
        images: images,
        collectionId: data?.collection_id,
      };

    case "shopify-section":
      return {
        id: data.id,
        name: data.name,
        url: data.url,
        imageUrl: data?.imageUrl,
        price: data?.variant_price,
        compareAtPrice: data?.variant_compare_at_price,
        membersPrice: data?.variant_mfield_pricing_members,
        tags: data.tags,
        swatches: swatches,
        images: images,
        collectionId: data?.collection_id,
      };
    case "shopify":
      return {
        id: data.id,
        name: data.title,
        url,
        imageUrl: data.images[0].src,
        price: parseFloat(data.variants[0].price) || 0,
        compareAtPrice: parseFloat(data.variants[0].compareAtPrice) || 0,
        membersPrice: parseFloat(data.variants[0].membersPrice) || 0,
        tags: data.tags,
        swatches: swatches,
        images: images,
        collectionId: [],
      };
  }
}
